export const CONST = {
  // BACKEND_URL: 'http://localhost:5000/api/v1',
  // BACKEND_HOST: 'http://localhost:5000/',


  // BACKEND_URL: 'http://172.105.43.238/api/v1',
  // BACKEND_HOST: 'http://172.105.43.238/',

  // SURVEY_URL: "http://172.105.43.238:8080//#/v1/",
  // SURVEY_LOGIN: "http://172.105.43.238:8080//#/login/",

  // SURVEY_ASSESSMENT: "http://172.105.43.238//#/assessment/surveylogin",
  // SURVEY_ASSESSMENT_USER: "http://172.105.43.238//#/assessment/sign-in",

  // IMAGES_URL: "http://172.105.43.238/images/",



  BACKEND_URL: 'https://coach.talentplusstrengths.com/api/v1',
  BACKEND_HOST: 'https://coach.talentplusstrengths.com/',

  SURVEY_URL: "https://coach.talentplusstrengths.com:8080//#/v1/",
  SURVEY_LOGIN: "https://coach.talentplusstrengths.com:8080//#/login/",

  SURVEY_ASSESSMENT: "https://coach.talentplusstrengths.com//#/assessment/surveylogin",
  SURVEY_ASSESSMENT_USER: "https://coach.talentplusstrengths.com//#/assessment/sign-in",

  IMAGES_URL: "https://coach.talentplusstrengths.com/images/",



  MERCHANT_ID: "2484086", //Int or String

  CRYPTO_KEY: "secretkey1345100237401", //Int or String

  R_KEY: "rzp_live_RWtn8JzDxoJ33F",

  MANAGER_ID_TYPE: "Int", //Int or String

  APP_NAME: 'PLUS HR',
  FOOTER_TEXT: '©2025 Happyplus. All rights reserved.',

};
